import React from "react";
import "./index.css";

const Footer = () => {
  return (
    <footer className={`footer`}>
      <p className="fText">
        © 2025 Raypath LLC. All rights reserved.
        <br /> <br />
        Address: 117 South Lexington Street Ste 100 Harrisonville, MO 64701.
      </p>
    </footer>
  );
};

export default Footer;
